import decode from 'jwt-decode'
import {validateAccount} from "../redux/actions/actionValidate";

export const isAuthenticated = () => {
    const token = localStorage.getItem('token')
    let isValid = true
    try {
        isValid = decode(token);
        isValid = {
            data: isValid,
            token: token
        }
    } catch (e) {
        return false
    }
    return isValid
}

export const processUrl = (query, param) => {
    const params = query.get(param);
    return params ? params : false;
}

